import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import i18n from "../../i18n";

const EmployeeScalePopup = ({ isOpen, toggle, employee, onConfirm, onCancel }) => {
  if (!employee) return null;

  const defaultAddress = employee.addresses?.[0]?.address;
  const employeeName = employee.name || i18n.t("Employee");
  const addressDescription = defaultAddress?.description || i18n.t("NoAddressRegistered");

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      centered
      size="lg"
    >
      <div className="modal-header-container">
        <p className="cancellation-title modal-header-bottom">
          {i18n.t("AddEmployeeAddressAsScale")}
        </p>
      </div>
      <div className="modal-separator" />
      <ModalBody>
        <div className="text-center mb-3">
          <i className="bx bx-map-pin scale-employee-icon" style={{ fontSize: "48px", color:"#FF5F00" }} />
        </div>
        <p 
          className="text-center"
          dangerouslySetInnerHTML={{
            __html: i18n.t("EmployeeHasDefaultAddress", {
              employeeName: `<strong>${employeeName}</strong>`,
              addressDescription: `<strong>${addressDescription}</strong>`
            })
          }}
        />
        <p className="text-muted text-center small">
          {i18n.t("ScalesCanModifyRoute")}
        </p>
        <div className="alert alert-info mt-3">
          <i className="bx bx-info-circle me-2" />
          {i18n.t("ScaleDecisionInfo")}
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button
          onClick={() => onConfirm(true)}
          className="btn btn-users border"
        >
          {i18n.t("YesUseAddressAsScale")}
        </Button>
        <Button
          color="secondary"
          onClick={() => onConfirm(false)}
          className="px-4 btn-custom-white border"
        >
          {i18n.t("NoContinueWithoutScale")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EmployeeScalePopup;
